<div class="flex-column flex-fill">
  <div class="dependent-items-header">Dependent Items</div>
  <ag-grid-angular #agGridFF
    class="ag-theme-balham"
    style="height: 100%;"
    (gridReady)="onGridReady($event)"
    [rowDragManaged]="true"
    [gridOptions]="gridOptions">
  </ag-grid-angular>
</div>